export default __webpack_public_path__ + "static/media/linkedIn-logo.124f7d4e.png";